import React, {Component} from "react";
import {Ajax} from "../../api/axios";
import {Annotation, Axis, Chart, Coordinate, Point} from "bizcharts";
import {message} from "antd";

interface IProps {
    hostName: string,
    metricName: string,
    height:number
}

interface IState {
    data: number
}

const scale = {
    value: {
        min: 0,
        max: 1,
        tickInterval: 0.1,
        formatter: (v: number) => v * 100
    }
}

class MetricPanel extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            data: 0
        };
    }

    getMetricData(host: string, metric: string) {
        var url = '/zabbix/metric?hostName=' + host + '&metricName=' + metric;
        Ajax.get<number>(url).then(res => {

            if (res.success) {
                this.setState({
                    data: res.data / 100
                })
            }
        }).catch(function (reason) {
            console.log('catch:', reason);
            message.error('获取数据失败', 3);
        })
    }

    componentDidMount() {
        this.getMetricData(this.props.hostName, this.props.metricName);
    }

    componentWillReceiveProps(nextProps: Readonly<IProps>, nextContext: any) {
        this.getMetricData(nextProps.hostName, nextProps.metricName)
    }

    render() {
        return (
            <Chart
                height={this.props.height}
                data={this.state.data}
                scale={scale}
                autoFit={true}
            >
                <Coordinate
                    type="polar"
                    radius={0.75}
                    startAngle={(-1.4) * Math.PI}
                    endAngle={(0.4) * Math.PI}
                />
                <Axis
                    name="value"
                    line={null}
                    visible={false}
                    label={{
                        offset: -36,
                        style: {
                            fontSize: 18,
                            textAlign: 'center',
                            textBaseline: 'middle',
                        },
                    }}

                    grid={null}
                />
                <Point
                    position="value*1"
                    color="#1890FF"
                    shape="pointer"
                />
                <Annotation.Arc
                    start={[0, 1]}
                    end={[1, 1]}
                    style={{
                        stroke: '#CBCBCB',
                        lineWidth: 18,
                        lineDash: null,
                        lineCap: 'round',
                    }}
                />
                <Annotation.Arc
                    start={[0, 1]}
                    end={[this.state.data, 1]}
                    style={{
                        stroke: '#1890FF',
                        lineCap: 'round',
                        lineWidth: 18,
                        lineDash: null,
                    }}
                />
                <Annotation.Text
                    position={['50%', '50%']}
                    content={`${Math.round(this.state.data * 100)}%`}
                    style={{
                        fontSize: 50,
                        fill: '#262626',
                        textAlign: 'center',
                    }}
                />
            </Chart>
        )
    }
}

export default MetricPanel;